export const baseURL = {
    development: 'https://dev-apaas.grtcloud.net/api',
    // test: 'https://test-apaas.grtcloud.net/api',
    test: 'https://test-apaas.grtcloud.net/api',
    production: 'https://apaas.grtcloud.net/api',
    local: 'http://127.0.0.1:4523/m1/1606492-0-4e213591'
}[process.env.REACT_APP_MODE];

export const baseURLNoApi = {
    development: 'https://dev-apaas.grtcloud.net',
    // test: 'https://test-apaas.grtcloud.net',
    test: 'https://test-apaas.grtcloud.net',
    production: 'https://apaas.grtcloud.net',
    local: 'http://127.0.0.1:4523/m1/1606492-0-4e213591'
}[process.env.REACT_APP_MODE];

export const loginURL = {
    development: 'https://dev-passport.grtcloud.net/',
    test: 'https://test-passport.grtcloud.net/',
    production: 'https://passport.grtcloud.net/',
    local: 'https://dev-passport.grtcloud.net/'
}[process.env.REACT_APP_MODE];
//神策埋点url
export const ShenCeUrl = {
    development: 'https://test-dc-ptc.grtcloud.net/',
    test: 'https://test-dc-ptc.grtcloud.net/',
    production: 'https://dc-ptc.grtcloud.net/',
    local: 'https://test-dc-ptc.grtcloud.net/'
}[process.env.REACT_APP_MODE];

export const DifyServer = {
    development: 'https://test-dify.grtcloud.net',
    test: 'https://test-dify.grtcloud.net',
    production: 'https://eagent.grtcloud.net',
    local: 'https://test-dify.grtcloud.net'
}[process.env.REACT_APP_MODE];

export const previewDocUrl = {
    // development: 'https://test-apaas.grtcloud.net/preview/onlinePreview?url=',
    development: 'https://test-apaas.grtcloud.net/preview/onlinePreview?url=',
    // test: 'https://test-apaas.grtcloud.net/preview/onlinePreview?url=',
    test: 'https://test-apaas.grtcloud.net/preview/onlinePreview?url=',
    production: 'https://apaas.grtcloud.net/preview/onlinePreview?url='
}[process.env.REACT_APP_MODE];
export const bucketName = {
    development: {
        video: 'ttcdw6-vod-video-test',
        audio: 'ttcdw6-vod-video-test',
        other: 'ttcdw6-public-test',
        oss: 'ttcdw6-file-test'
    },
    test: {
        video: 'ttcdw6-vod-video-test',
        audio: 'ttcdw6-vod-video-test',
        other: 'ttcdw6-public-test',
        oss: 'ttcdw6-file-test'
    },
    production: {
        video: 'ttcdw6-vod-video',
        audio: 'ttcdw6-vod-video',
        other: 'ttcdw6-public',
        oss: 'ttcdw6-file'
    }
}[process.env.REACT_APP_MODE];
